import { gql, TypedDocumentNode } from '@common/hooks';
import {
  UpdateTierMutationCgResponse,
  UpdateTierMutationVariables,
} from '@common/graphql/schema';

export const UpdateTierMutation: TypedDocumentNode<
  UpdateTierMutationCgResponse,
  UpdateTierMutationVariables
> = gql`
  mutation UpdateTier($tierId: ID!, $input: UpdateTierInput!) {
    updateTier(tierId: $tierId, input: $input) {
      tier {
        id
        name
      }
      errors {
        ... on NotFoundError {
          message
        }
        ... on BadUserInputError {
          message
        }
        ... on ModelValidationError {
          message
        }
        ... on RecordNotUniqueError {
          message
        }
      }
    }
  }
`;
